<script>
import responsiveMixin from '@/mixins/responsiveMixin';
import routeNames from '@/router/routeNames';
import { helpers as notificationHelpers } from '@/store/modules/notifications';
import { helpers as researcherHelpers } from '@/store/modules/researcherSignup';
import { SET_FIELDS, SHOW_SNACKBAR } from '@/store/types';
import Api from '@/utils/api';
import * as Segment from '@/utils/segment';
import { exists, isUrl } from '@/utils/validationRules';
import _ from 'lodash';
import moment from 'moment-timezone';

export default {
  mixins: [responsiveMixin],
  data: () => ({
    isSubmitting: false,
    formIsValid: false,
    name: '',
    rules: {
      exists: () => true,
      isUrl: () => true,
    },
    website: '',
  }),
  methods: {
    ...researcherHelpers.mapMutations({ setInStore: SET_FIELDS }),
    ...notificationHelpers.mapActions({ showSnackbar: SHOW_SNACKBAR }),
    handleSaveError(message) {
      this.isSubmitting = false;
      this.showSnackbar({ message });
    },
    setRules() {
      this.rules = {
        exists,
        isUrl,
      };
    },
    async save() {
      this.setRules();
      this.$nextTick(async () => {
        await this.$refs.form.validate();
        try {
          if (!this.formIsValid) return;
          this.isSubmitting = true;

          const organization = {
            name: this.name,
            website: this.website,
            timezone: moment.tz.guess(),
          };

          const {
            data: { success, message, response },
          } = await Api.post(
            '/dashboard/organizations/settings/create',
            organization
          );
          if (!success) return this.handleSaveError(message);

          this.trackSegmentOrgCreation(response.id);
          this.setInStore({ organization: response });
          this.$router.push({ name: routeNames.personal });
        } catch (e) {
          this.handleSaveError(
            'There was a problem saving your organization. Please try again later.'
          );
        }
      });
    },
    trackSegmentOrgCreation(id) {
      Segment.trackResearcher('Organization', {
        id,
        country: _.get(this, 'location.country'),
        city: _.get(this, 'location.city'),
        name: this.name,
      });
    },
  },
};
</script>

<template>
  <v-row>
    <v-col cols="12" md="7">
      <h1
        :class="
          responsiveClasses({
            desktop: 'display-4 mb-5',
            tablet: 'display-3 mb-4',
          })
        "
      >
        Let's Get Started! <br />
        Create an Organization
      </h1>
      <p class="mb-8">
        An “organization” allows you to have a collaborative account where you
        and your team can create and share projects.
      </p>
      <v-form
        ref="form"
        v-model="formIsValid"
        method="POST"
        @submit.prevent="save"
      >
        <base-input
          v-model="name"
          :value="name"
          label="Organization Name"
          name="name"
          placeholder="Jane Doe Organization"
          :rules="[rules.exists]"
          type="text"
        />
        <base-input
          v-model="website"
          label="Organization Website"
          name="website"
          placeholder="https://janedoeorganization.com"
          :rules="[rules.exists, rules.isUrl]"
          type="url"
          :value="website"
        />

        <v-btn
          v-if="!isMobileOrTablet"
          color="primary"
          type="submit"
          :min-width="260"
          :loading="isSubmitting"
        >
          Next
        </v-btn>
      </v-form>
    </v-col>

    <v-col v-if="isMobileOrTablet" cols="12">
      <v-btn
        color="primary"
        type="button"
        block
        :loading="isSubmitting"
        @click="save"
      >
        Next
      </v-btn>
    </v-col>
  </v-row>
</template>
